import React from 'react'
import Typewriter from "typewriter-effect";
function Typeeffect() {
  return (
    <div className='type'>
       <Typewriter
options={ 
    {loop: true,
    delay: 75,
    }}
 onInit={(typewriter) => {
     typewriter
         .typeString("Welcome to my portfolio Website!!!")
         .pauseFor(800)
         .deleteAll()
         .typeString("I am a Full Stack Web Developer.")
         .pauseFor(500)
         .deleteAll()
         .typeString("I am a Full Stack Java Developer.")
         .pauseFor(500)
         .deleteAll()
         .typeString("I am a MERN Developer.")
         .pauseFor(500)
         .deleteAll()
         .typeString("I have Knowledge of Data Structure and Algorithm.")
         .pauseFor(500)
         .deleteAll()
         .typeString("I have knowledge of git version control.")
         .pauseFor(500)
         .deleteAll()
         .typeString("I have knowledge of DBMS.")
         .pauseFor(500)
         .deleteAll()
         .typeString("I have knowledge of Operating System.")
         .pauseFor(500)
         .deleteAll()
         .typeString("I have knowledge of LINUX.")
         .start();
        
 }}
/>
    </div>
  )
}

export default Typeeffect
